import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useUIStore } from '../../../../hooks/stores/uiStore';
import { GradientPage } from './GradientPage';
import { SolidColorPage } from './SolidColorPage';

type Pages = 'solid' | 'gradient';

export const ColorPickerModalContent = ({
  value,
  onChange,
  onlySolid,
  defaultSwatchesTarget,
}: {
  value?: string | null;
  onChange: (newValue: string | undefined) => void;
  onlySolid?: boolean;
  defaultSwatchesTarget?: string;
}) => {
  const [UIData] = useUIStore();
  const isGradient = value?.includes('gradient');

  const [currentPage, setCurrentPage] = useState<Pages>(isGradient ? 'gradient' : 'solid');

  const drawPage = () => {
    switch (currentPage) {
      case 'solid':
        return <SolidColorPage value={value} onChange={onChange} />;
      case 'gradient':
        return <GradientPage value={value} onChange={onChange} />;
    }
  };

  useEffect(() => {
    setCurrentPage(isGradient ? 'gradient' : 'solid');
  }, [UIData.selectedElementIDs, value]);

  return onlySolid ? (
    <SolidColorPage value={value} onChange={onChange} defaultSwatchesTarget={defaultSwatchesTarget} />
  ) : (
    <>
      <ButtonsContainer>
        <TextButton
          $isActive={currentPage === 'solid'}
          onClick={() => {
            setCurrentPage('solid');
            onChange('#000000');
          }}
        >
          Solid
        </TextButton>
        <TextButton
          $isActive={currentPage === 'gradient'}
          onClick={() => {
            setCurrentPage('gradient');
            onChange('linear-gradient(90deg, #000000 0%, #00000000 100%)');
          }}
        >
          Gradient
        </TextButton>
      </ButtonsContainer>

      {drawPage()}
    </>
  );
};

const ButtonsContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  padding: 5px;
  gap: 2px;
`;

const TextButton = styled.div<{ $isActive?: boolean }>`
  cursor: pointer;
  padding: 3px 10px;

  border-radius: var(--radius-2);
  color: var(--main-2);
  font-size: 11px;

  transition:
    color var(--transition-2),
    background-color var(--transition-2);

  &:hover {
    color: var(--main-1);
    background-color: var(--neutral-3);
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    color: var(--main-1);
    background-color: var(--neutral-3);
  `}
`;
